<script>
import api from '@/helpers/api'

export default {
  name: 'open-orders-stat-card',
  props: {
    status: {
      type: String
    }
  },
  data () {
    return {
      counter: 0
    }
  },
  async mounted () {
    let filters = [
      { status: { _eq: this.status } },
      { is_submitted: { _eq: true } }
    ]
    let { count } = await api.webForms.countWhere({
      filters
    })
    this.counter = this.$options.filters.thousands(count, 2)
  },
  methods: {
    navigate () {
      this.$router.push({
        name: 'sales.my-orders',
        query: { status: this.status }
      })
    }
  }
}
</script>
<template>
  <g-stat-card
    class="pointer"
    v-on:click="navigate"
    :title="$t(`web_form_status.${status}.text`) + ' ' + $t('orders')"
    :stat="counter"
    :variant="$t(`web_form_status.${status}.color`)"
    :icon="$t(`web_form_status.${status}.icon`)"
  />
</template>
